import { Application } from '@hotwired/stimulus'

export const startStimulus = () => {
  const application = Application.start()

  document.addEventListener('turbo:before-cache', () => {
    application.controllers.forEach(controller => {
      if (typeof controller.teardown === 'function') {
        controller.teardown()
      }
    })
  })

  return application
}
